import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { BASE_PUBLIC_ASSETS_URL, LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News1ComponentState {
    activeLanguage: string | undefined;
}

const SUMMARY_FILE_URL = `${BASE_PUBLIC_ASSETS_URL}/Podsumowanie_konsultacji_-_projekt_dronowy_KPO.pdf`;

@Component({
    selector: "dtm-main-page-lib-news-1",
    templateUrl: "./news-1.component.html",
    styleUrls: ["./news-1.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News1Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly SUMMARY_FILE_URL = SUMMARY_FILE_URL;

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<News1ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
